import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import classNames from 'classnames';
import PDPNameSectionPlaceholder from './PDPNameSection/PDPNameSectionPlaceholder';
import PDPShopTabsBarPlaceholder from './PDPShopTabsBar/PDPShopTabsBarPlaceholder';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptions/PDPChooseYourOptionsPlaceholder';
import PDPProtectionPlanSelectorPlaceholder from './PDPProtectionPlanSelector/PDPProtectionPlanSelectorPlaceholder';
import PDPAddToBagSectionPlaceholder from './PDPAddToBagSection/PDPAddToBagSectionPlaceholder';

/**
 * Hero-promise Suspense fallback: large image rect + minimal chrome.
 * Intentionally lighter than full-page PDPPlaceholder.
 */
const PDPHeroShellPlaceholder = t0 => {
  const $ = _c(16);
  const {
    className: parentClassName
  } = t0;
  let t1;
  if ($[0] !== parentClassName) {
    t1 = classNames("hidden lg:flex mx-auto my-0 py-0 flex-row-reverse !pt-2 !pb-8 px-5 md:px-[3.333vw] min-[1500px]:px-[50px] max-w-[1800px]", parentClassName);
    $[0] = parentClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]"><PDPNameSectionPlaceholder /><PDPShopTabsBarPlaceholder /><PDPChooseYourOptionsPlaceholder /><PDPProtectionPlanSelectorPlaceholder /><PDPAddToBagSectionPlaceholder /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex-1 mr-12"><div className="sticky top-8"><div className="mb-8 flex flex-col items-center relative max-w-[calc((100vh - 194px) / 0.6666666666666666)]"><Placeholder loading={true} type="rect" style={{
            width: "50vw",
            height: "70vh",
            margin: "none"
          }} /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className={t1} data-xc="PDPHeroShellPlaceholder-desktop">{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== parentClassName) {
    t5 = classNames("flex flex-col lg:hidden", parentClassName);
    $[6] = parentClassName;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]"><PDPNameSectionPlaceholder /></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Placeholder className="mb-1.5" loading={true} type="rect" style={{
      width: "100vw",
      aspectRatio: "1/1"
    }} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]"><PDPChooseYourOptionsPlaceholder /><PDPProtectionPlanSelectorPlaceholder /><PDPAddToBagSectionPlaceholder /></div>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t5) {
    t9 = <div className={t5} data-xc="PDPHeroShellPlaceholder-mobile">{t6}{t7}{t8}</div>;
    $[11] = t5;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t4 || $[14] !== t9) {
    t10 = <>{t4}{t9}</>;
    $[13] = t4;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
PDPHeroShellPlaceholder.propTypes = {
  className: PropTypes.string
};
export default PDPHeroShellPlaceholder;